module.exports = __webpack_public_path__ + "18e15358d413e700d151f97ecd90ea63.svg";